
























































































import {Component, Vue} from 'vue-property-decorator'
import HelloWorld from '@/components/HelloWorld.vue'
import GorgeousHeader from '@/components/GorgeousHeader.vue'
import BlackHeader from '@/components/BlackHeader.vue'
import BlackHeaderHamburger from '@/components/BlackHeaderHamburger.vue'
import ChatBot from '@/components/ChatBot.vue' // @ is an alias to /src

@Component({
  components: {
    ChatBot,
    BlackHeaderHamburger,
    BlackHeader,
    GorgeousHeader,
    HelloWorld
  }
})
export default class Home extends Vue {
  isSmartPhoneWidth = window.innerWidth <= 768
}
